import {
  DATASET_ERROR,
  DATA_LOADING,
  DATASET_DOWNLOADING,
  DATASET_UPLOAD_PROGRESS,
  SET_DATA_SUMMARY,
  SET_DATASET,
  SET_DATASETS,
  CREATE_DATASET,
  SET_FILTERS,
  UPLOAD_DATASET_FILE,
  REMOVE_DATASET_FILE,
  APPLY_MAPPED_COLUMNS,
  RESET_DATASETS,
} from "../constants";

const initial_state = {
  loading: {},
  errors: {},
  summary: {
    /* total, email_count, text_count, voice_count, last_update */
  },
  list: [], // Array of datasets
  selected: {}, // Selected Dataset
  filters: [], // Array of filter options
  files: [], // Array of File objects
  column_names: [
    { label: "Customer Name", value: "customer_name_vch" },
    { label: "Customer Address 1", value: "address1_vch" },
    { label: "Customer Address 2", value: "address2_vch" },
    { label: "Customer City", value: "city_vch" },
    { label: "Customer State", value: "state_vch" },
    { label: "Customer Zip", value: "zip_vch" },
  ],
};

export default function (state = initial_state, { type, payload }) {
  const { files, loading, errors } = state;
  switch (type) {
    case DATASET_UPLOAD_PROGRESS:
      loading["uploadprogress"] = payload;
      return {
        ...state,
        loading,
      };
    case DATASET_DOWNLOADING:
      loading["downloading"] = payload;
      return {
        ...state,
        loading,
      };
    case DATA_LOADING:
      loading[payload] = true;
      return {
        ...state,
        loading,
      };

    case DATASET_ERROR:
      Object.keys(payload).forEach((key) => (loading[key] = false));
      return {
        ...state,
        loading,
        errors: payload || { unknown: "Unknown error" },
      };

    case SET_DATA_SUMMARY:
      delete loading.summary;
      delete errors.summary;

      return {
        ...state,
        errors,
        summary: payload,
      };

    case SET_DATASETS:
      delete loading.datasets;
      delete errors.datasets;

      return {
        ...state,
        errors,
        list: payload,
      };

    case SET_DATASET:
      delete loading.dataset;
      delete errors.dataset;

      return {
        ...state,
        errors,
        selected: payload,
      };

    case SET_FILTERS:
      delete loading.filters;
      delete errors.filters;

      return {
        ...state,
        errors,
        filters: payload,
      };

    case UPLOAD_DATASET_FILE:
      // Uses { files } = state; from above

      // Prevent duplicate files from populating
      const stored = new Set(files.map((file) => file.name));
      payload = payload.filter((file) => !stored.has(file.name) && stored.add(file.name));

      return {
        ...state,
        files: [...files, ...payload],
      };

    case REMOVE_DATASET_FILE:
      // Uses { files } = state; from above
      const filtered_files = files.filter((file) => !payload.includes(file.name));

      return {
        ...state,
        files: filtered_files,
      };

    case APPLY_MAPPED_COLUMNS:
      const selected = { ...state.selected };

      selected.mapped_columns = payload;

      return {
        ...state,
        selected,
      };

    case CREATE_DATASET:
      delete loading.create;
      delete errors.create;

      return {
        ...state,
        files: [],
      };

    case RESET_DATASETS:
      return { ...initial_state };

    default:
      return state;
  }
}
